'use strict';

/*global window, global*/

var root = typeof window !== 'undefined' ?
    window : typeof global !== 'undefined' ?
    global : {};

module.exports = Individual;

function Individual(key, value) {
    if (key in root) {
        return root[key];
    }

    root[key] = value;

    return value;
}



//////////////////
// WEBPACK FOOTER
// ./~/individual/index.js
// module id = 49
// module chunks = 0